export const SITE_BASE_URL = process.env.NODE_ENV === 'development' ? "http://localhost:8080/" : "https://watch.rw/";
export const ADMIN_BASE_URL = process.env.NODE_ENV === 'development' ? "http://localhost:8081/" : "https://admin.watch.rw/";
export const BASE_URL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:8000/" : "https://api-watch.wecodefy.com/";
export const MEDIA_SERVER_BASE_URL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3000" : "https://media-server-api.watch.rw";
export const SOCKET_SERVER_SOCKET_BASE_URL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3011/" : "https://ws.watch.rw/";


export const STREAMING_CDN_SERVER_BASE_URL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3001" : "https://wetest.fra1.cdn.digitaloceanspaces.com";
export const LIVE_STREAMING_CDN_SERVER_BASE_URL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3001" : "https://cdn.watch.rw";
export const WEBRTC_STREAMING_SERVER_BASE_URL = process.env.NODE_ENV === 'development' ? "ws://127.0.0.1:3333" : "wss://webrtc-streaming.watch.rw";

export const PROXY_SERVER_HOST_URL = process.env.NODE_ENV === 'development' ? "127.0.0.1:3012" : "proxy.watch.rw";
export const PROXY_SERVER_PROTOCOL_URL = process.env.NODE_ENV === 'development' ? "http" : "https";
export const MEDIA_SERVER_API_BASE_URL = process.env.NODE_ENV === 'development' ? MEDIA_SERVER_BASE_URL + "/api/v1" : MEDIA_SERVER_BASE_URL + "/api/v1";
export const API_NODE_BASE_URL = SOCKET_SERVER_SOCKET_BASE_URL + "node/api";

export const ASSETS_BASE_URL = 'https://cagura-assets.b-cdn.net/';
export const ASSETS_VIDEO_BASE_URL = 'https://wecodefy.fra1.cdn.digitaloceanspaces.com/';
export const API_BASE_URL = BASE_URL + 'api/v1/admin';
export const API_SITE_BASE_URL = BASE_URL + 'api/v1';
export const BUNNY_CDN_BASE_URL = "https://storage.bunnycdn.com";
export const CLOUDFLARE_API_BASE_URL = "https://api.cloudflare.com/client/v4/accounts/";

// KEYS
export const BUNNY_CDN_ACCESS_API_KEY = "9de4212d-5d04-483a-93852d1a67c5-9bef-445e";

// Auth tokens
export const GOOGLE_API_KEY = 'AIzaSyCSgy2lCrl7LrZoX5lvBDdP6ar0m6l6wb4';
export const GOOGLE_MAP_KEY = 'AIzaSyC4scenSTK8lTrQMFF1GwaB9JICHEras34';


/* ---------------------------------------------------------------
 * API LIST
 ----------------------------------------------------------------*/
// Auth api
export const ACCOUNT_LOGIN_URL = "/account/login";
export const VERIFY_TOKEN_URL = "/account/verify/token";

// Users
export const ADMIN_USER_DELETE_ITEM_URL = "/account/delete";
export const ADMIN_USER_GET_USERS_URL = "/account/get/all";
export const ADMIN_USER_ADD_NEW_URL = "/account/create";
export const ADMIN_USER_UPDATE_URL = "/account/update";
export const SAVE_PERMISSION_ITEM_URL = "/account/save/permission"
export const ADMIN_GET_PERMSSION_LIST_URL = "/account/get/permission/list"
export const ADMIN_CHANGE_PERMSSION_URL = "/account/change/permission";
export const SEARCH_BASED_CATEGORY_URL = "/search/based/category";
export const GET_DASHBOARD_DATA_URL = "/dashboard/all";
export const GET_ALL_CAGURA_USER_URL = "/get/cagura/user";
export const USER_CUSTOMER_GET_ALL_URL = "/user/customers"
export const ADMIN_USER_GET_ACCOUNT_OVERVIEW_URL = "/account/overview";
export const ADMIN_USER_FUNDS_OVERVIEW_URL = "/account/funds/overview";
export const ADMIN_USER_GET_SUBSCRIPTION_REPORT_URL = "/account/subscription/report";
export const ADMIN_USER_STREAMING_REPORT_URL = "/account/streaming/report";
export const ADMIN_USER_UPDATE_INFO_URL = "/account/update/info";
export const USER_GET_INFORMATION_URL = "/user/get/information";
export const ADMIN_USER_TRANSATION_REPORT_URL = "/account/transaction/report";
export const ADMIN_USER_DOWNLOAD_TRANSATION_REPORT_URL = "/account/download/transaction/report";
export const ADMIN_USER_UPDATE_PERMISSIONS_URL = "/account/update/permissions";
export const ADMIN_USER_SAVE_WEBSITE_THEME_URL = "/account/save/website/theme";
export const ADMIN_USER_GET_WEBSITE_THEME_URL = "/account/get/website/theme";
export const ADMIN_USER_RESET_WEBSITE_THEME_URL = "/account/reset/website/theme";
export const ADMIN_USER_TOGGLE_LANDING_PAGE_URL = "/account/toggle/landing/page";
export const ADMIN_USER_REGISTER_WEB_DOMAIN_URL = "/account/register/web/domain";
export const ADMIN_USER_CONFIG_WEB_SSL_URL = "/account/config/web/ssl";
export const ADMIN_USER_REMOVE_WEB_DOMAIN_CONFIG_URL = "/account/remove/web/domain/config";
export const ADMIN_USER_SHOW_CONTENT_ON_ORIGINAL_SITE_URL = "/account/show/content/on/original/site";
export const ADMIN_USER_GENERATE_STREAMING_TICKETS_URL = "/account/generate/streaming/tickets";
export const ADMIN_USER_GENERATE_EVENT_TICKETS_URL = "/account/generate/event/tickets";
export const ADMIN_USER_DOWNLOAD_FREE_TICKETS_URL = "/account/download/free/tickets";
export const ADMIN_USER_UPDATE_DEFAULT_INDEX_PAGE_URL = "/account/update/default/index/page";
export const ADMIN_USER_UPDATE_PASSWORD_URL = "/account/update/password";
export const STREAMER_USER_GENERATE_CHANNEL_API_KEY_URL = "/channel/generate/api/key";
export const STREAMER_USER_GET_CHANNEL_API_KEY_URL = "/channel/get/api/key";


// Upload api
export const UPLOAD_GET_ALL_FILES_URL = "/upload/all-files";
export const UPLOAD_DELETE_FILE_URL = "/upload/delete";
export const UPLOAD_SEARCH_FILE_URL = "/upload/search";
export const UPLOAD_SEARCH_FILE_BY_TYPE_URL = "/upload/search-by-type";
export const UPLOAD_UPDATE_FILE_URL = "/upload/update-file";
export const UPLOAD_SAVE_UPLOADED_FILE_URL = "/upload/save/filename";
export const UPLOAD_TO_BUNNY_CDN_URL = "/cagura/assets/uploaded/";

// Channel api
export const CHANNEL_GET_MY_DETAILS_URL = "/channel/get/my/details";
export const CHANNEL_GET_MY_VIDEOS_URL = "/channel/get/my/videos";
export const CHANNEL_UPDATE_DETAILS_URL = "/channel/update/details";
export const CHANNEL_ADD_VIDEO_URL = "/channel/add/video";
export const CHANNEL_UPDATE_VIDEO_URL = "/channel/update/video";
export const CHANNEL_DELETE_VIDEO_URL = "/channel/delete/video";
export const CHANNEL_GET_VIDEO_DETAILS_URL = "/channel/get/video/details";

// Super admin channel api
export const CHANNEL_GET_ALL_URL = "/channel/get/all";
export const CHANNEL_GET_ALL_EVENTS_URL = "/channel/get/all/events";
export const CHANNEL_SET_EVENT_AS_SPONSORED_URL = "/channel/set/event/as/sponsored";
export const CHANNEL_GET_ALL_VOTING_SESSIONS_URL = "/channel/get/all/voting/sessions";
export const CHANNEL_RECALCULATE_VOTING_TRANSACTIONS_URL = "/channel/recalculate/voting/transactions";
export const CHANNEL_SET_ITEM_AS_SPONSORED_URL = "/channel/set/item/as/sponsored";
export const CHANNEL_GET_ALL_VIDEOS_URL = "/channel/get/all/videos";

// Streaming
export const STREAMING_ADDNEW_TV_URL = "/streaming/add/tv";
export const STREAMING_UPDATE_TV_URL = "/streaming/update/tv";
export const STREAMING_ALL_TVs_URL = "/streaming/all/tvs";
export const STREAMING_DELETE_TV_URL = "/streaming/delete/tv";

// User streaming api
export const STREAMING_GET_MY_ACTIVE_STREAM_URL = "/streaming/mine/active/stream";
export const STREAMING_UPDATE_MY_STREAM_URL = "/streaming/mine/update/stream";
export const STREAMING_UPDATE_MY_STREAM_DETAILS_URL = "/streaming/mine/update/stream/details";
export const STREAMING_GET_MY_EVENT_EARNINGS_URL = "/streaming/mine/get/event/earnings";
export const STREAMING_GET_MY_EVENT_CHATS_URL = "/streaming/mine/get/event/chats";
export const STREAMING_CHECK_STREAM_STATUS_URL = "/streaming/check/stream/status";
export const STREAMING_ADD_STREAM_LOCATION_URL = "/streaming/mine/add/stream/location";
export const STREAMING_UPDATE_STREAM_LOCATION_URL = "/streaming/mine/update/stream/location";
export const STREAMING_DELETE_STREAM_LOCATION_URL = "/streaming/mine/delete/stream/location";
export const STREAMING_GET_ALL_STREAM_LOCATION_URL = "/streaming/mine/get/all/stream/location";
export const STREAMING_GET_STREAM_SESSIONS_URL = "/streaming/storage";
export const STREAMING_SET_DEFAULT_DEMPED_HLS_URL = "/streaming/set/default/demped/hls";
export const STREAMING_GET_EVENT_VIEWS_URL = "/streaming/get/event/views";
export const STREAMING_GET_PAST_STREAMS_URL = "/streaming/get/past/streams";
export const STREAMING_UPDATE_STREAM_URL = "/streaming/update/stream";
export const STREAMING_SET_STREAM_ACTIVE_URL = "/streaming/set/stream/active";
export const STREAMING_DELETE_STREAM_URL = "/streaming/delete/stream";
export const STREAMING_DELETE_STREAM_SESSION_URL = "/streaming/delete/stream/session";
export const STREAMING_MERGE_STREAM_URL = "/streaming/merge/stream";
export const STREAMING_DOWNLOAD_STREAM_URL = "/streaming/download/stream";
export const STREAMING_GET_STREAM_DOWNLOADS_URL = "/streaming/stream/downloads";
export const STREAMING_GET_STREAM_ANALYTICS_URL = "/streaming/stream/analytics";
export const STREAMING_GET_STREAM_LOGS_URL = "/streaming/stream/logs";
export const STREAMING_GET_STREAM_HEALTH_URL = "/streaming/stream/health";
export const STREAMING_ADD_MY_STREAM_URL = "/streaming/mine/add/stream";
export const STREAMING_CLOSE_MY_STREAM_URL = "/streaming/close/my/stream";
export const STREAMING_END_MY_STREAM_URL = "/streaming/end/my/stream";
export const STREAMING_SEND_MY_EVENT_CHAT_URL = "/streaming/send/my/event/chat";

// Pricing api
export const PRICING_ADD_PRICING_URL = "/pricing/add";
export const PRICING_GET_PRICING_URL = "/pricing/get";
export const PRICING_UPDATE_PRICING_URL = "/pricing/update";
export const PRICING_DELETE_PRICING_URL = "/pricing/delete";

// Report
export const REPORT_GET_ALL_URL = "/report/all/reported";
export const REPORT_DELETE_REPORTED_ITEM_URL = "/report/delete/reported/item";



// Support chat
export const SUPPORT_CHAT_GET_CONVERSATIONS_URL = "/support/chat/conversations";
export const SUPPORT_CHAT_GET_CONVERSATION_MESSAGES_URL = "/support/chat/conversation/messages";
export const SUPPORT_CHAT_SEND_MESSAGE_URL = "/support/chat/send/message";
export const SUPPORT_CHAT_DELETE_CONVERSATION_URL = "/support/chat/delete/conversation";
export const SUPPORT_CHAT_CHANGE_CONVERSATION_STATUS_URL = "/support/chat/change/conversation/status";
export const SUPPORT_CHAT_GET_USER_SUBCRIPTION_URL = "/support/chat/sub/info";
export const SUPPORT_CHAT_CHANGE_SUBSCRIPTION_STATUS_URL = "/support/chat/sub/change/status";
export const SUPPORT_CHAT_DELETE_SUBSCRIPTION_URL = "/support/chat/sub/delete";
export const SUPPORT_CHAT_ADD_SUBCRIPTION_URL = "/support/chat/sub/add";
export const SUPPORT_CHAT_CHANGE_TICKET_STATUS_URL = "/support/chat/change/ticket/status";
export const SUPPORT_CHAT_DELETE_TICKET_URL = "/support/chat/delete/ticket";

// Finance
export const FINANCE_TRANSATIONS_GET_ALL_URL = "/finance/transations";
export const FINANCE_PRICING_MOVIE_ADDNEW_URL = "/finance/pricing/addnew";
export const FINANCE_PRICING_MOVIE_UPDATE_URL = "/finance/pricing/update";
export const FINANCE_PRICING_GET_ALL_URL = "/finance/pricing";
export const FINANCE_PRICING_MOVIE_DELETE_URL = "/finance/pricing/delete";
export const FINANCE_SETTLEMENT_DELETE_URL = "/finance/settlement/delete";
export const FINANCE_SETTLEMENT_ADDNEW_URL = "/finance/settlement/addnew";
export const FINANCE_SETTLEMENT_UPDATE_URL = "/finance/settlement/update";
export const FINANCE_SETTLEMENT_GET_ALL_URL = "/finance/settlements";
export const FINANCE_GET_BANK_BALANCE_URL = "/finance/get/bank/balance";

// Settings
export const SETTINGS_PAYMENT_BESOFT_UPDATE_URL = "/settings/update";
export const SETTINGS_GET_ALL_URL = "/settings/get/all";
export const SETTINGS_ANNOUNCEMENT_GET_ALL_URL = "/settings/announcements";
export const SETTINGS_ANNOUNCEMENT_ADDNEW_URL = "/settings/announcements/add";
export const SETTINGS_ANNOUNCEMENT_UPDATE_URL = "/settings/announcements/update";
export const SETTINGS_ANNOUNCEMENT_DELETE_URL = "/settings/announcements/delete";

// Ads
export const ADS_GET_CONTACTS_URL = "/ads/contacts";
export const ADS_CHANGE_CONTACT_STATUS_URL = "/ads/contacts/change/status";
export const ADS_DELETE_CONTACT_URL = "/ads/contacts/delete";

// VOTING
export const VOTING_GET_MY_VOTING_SESSIONS_URL = "/voting/mine/get/sessions";
export const VOTING_DELETE_MY_VOTING_SESSION_URL = "/voting/delete/my/voting/session";
export const VOTING_ADDNEW_VOTING_SESSION_URL = "/voting/addnew/voting/session";
export const VOTING_UPDATE_VOTING_SESSION_URL = "/voting/update/voting/session";
export const VOTING_REINDEX_SESSION_URL = "/voting/reindex/session";

export const VOTING_GET_ALL_MY_VOTING_CATEGORIES_URL = "/voting/mine/get/all/categories";
export const VOTING_DELETE_MY_VOTING_CATEGORY_URL = "/voting/delete/my/voting/category";
export const VOTING_ADDNEW_VOTING_CATEGORY_URL = "/voting/addnew/voting/category";
export const VOTING_UPDATE_VOTING_CATEGORY_URL = "/voting/update/voting/category";

export const VOTING_GET_MY_VOTING_PARTICIPANTS_URL = "/voting/mine/get/participants";
export const VOTING_DELETE_MY_VOTING_PARTICIPANT_URL = "/voting/delete/my/voting/participant";
export const VOTING_ADDNEW_VOTING_PARTICIPANT_URL = "/voting/addnew/voting/participant";
export const VOTING_UPDATE_VOTING_PARTICIPANT_URL = "/voting/update/voting/participant";
export const VOTING_GET_MY_VOTING_PARTICIPANTS_REPORT_URL = "/voting/mine/get/participants/report";

export const VOTING_GET_VOTING_SESSION_PRICING_WITH_TOPUP_FEE_URL = "/voting/get/voting/session/pricing/with/topup/fee";
export const VOTING_TOPUP_VOTES_TO_PARTICIPANT_URL = "/voting/topup/votes/to/participant";
export const VOTING_ADD_VOTES_MANUALLY_URL = "/voting/add/votes/manually";
export const VOTING_GET_ADDED_VOTES_HISTORY_URL = "/voting/get/added/votes/history";
export const VOTING_DUPLICATE_SESSION_URL = "/voting/duplicate/session";
export const VOTING_GET_VOTING_SESSIONS_URL = "/voting/get/voting/sessions";

// Nomination URLs (using backend implementation)
export const VOTING_GET_SESSION_NOMINEES_URL = "/voting/get/session/nominees";
export const VOTING_UPDATE_NOMINEE_STATUS_URL = "/voting/update/nominee/status";
export const VOTING_MOVE_NOMINEE_TO_PARTICIPANT_URL = "/voting/move/nominee/to/participant";
export const VOTING_DELETE_NOMINEE_URL = "/voting/delete/nominee";

// Participant URLs
export const PARTICIPANT_LOGIN_URL = "/participant/login";
export const PARTICIPANT_GET_DASHBOARD_URL = "/participant/dashboard";
export const PARTICIPANT_UPDATE_PROFILE_URL = "/participant/profile";
export const PARTICIPANT_LOGOUT_URL = "/participant/logout";
export const PARTICIPANT_GET_TRANSACTIONS_URL = "/participant/transactions";
export const PARTICIPANT_GET_INVOICES_URL = "/participant/invoices";
export const PARTICIPANT_GET_INVOICE_URL = "/participant/invoices/get";
export const PARTICIPANT_CREATE_INVOICE_URL = "/participant/invoices/create";
export const PARTICIPANT_UPDATE_INVOICE_URL = "/participant/invoices/update";
export const PARTICIPANT_DELETE_INVOICE_URL = "/participant/invoices/delete";

// Participant Rewards URLs
export const VOTING_GET_PARTICIPANT_REWARDS_HISTORY_URL = "/voting/get/participant/rewards/history";
export const VOTING_ADD_PARTICIPANT_REWARD_URL = "/voting/add/participant/reward";
export const VOTING_UPDATE_PARTICIPANT_REWARD_URL = "/voting/update/participant/reward";
export const VOTING_DELETE_PARTICIPANT_REWARD_URL = "/voting/delete/participant/reward";

// EVENTS
export const EVENTS_GET_ALL_EVENTS_URL = '/events/get/all';
export const EVENTS_ADD_NEW_EVENT_URL = '/events/add/new';
export const EVENTS_UPDATE_EVENT_URL = '/events/update/';
export const EVENTS_DELETE_EVENT_URL = '/events/remove/';
export const EVENTS_UPDATE_USSD_ID_URL = '/events/update/ussd/id';
export const EVENTS_GET_EVENTS_BY_TYPE_URL = '/events/item/tickets';
export const EVENTS_GET_TICKET_DETAILS_URL = '/events/ticket/details';
export const EVENTS_APPROVE_TICKET_URL = '/events/approve/ticket';
export const EVENTS_SEARCH_TICKET_URL = '/events/search/ticket';
export const EVENTS_GET_BOOKING_FORM_DATA_URL = '/events/get/booking/form/data';
export const EVENTS_DELETE_EVENT_TICKET_URL = '/events/delete/ticket';
export const EVENTS_RESEND_TICKET_SMS_URL = '/events/resend/ticket/sms';
export const EVENTS_DELETE_BOOKING_URL = '/events/delete/booking';
export const EVENTS_GET_ALL_PRE_SELL_TICKETS_URL = '/events/get/all/pre/sell/tickets';
export const EVENTS_DELETE_PRE_SELL_TICKET_URL = '/events/delete/pre/sell/ticket';
export const EVENTS_DOWNLOAD_PRE_SELL_TICKET_URL = '/events/download/pre/sell/ticket';
export const EVENTS_ACTIVATE_TICKET_URL = '/events/activate/ticket';
export const EVENTS_DOWNLOAD_INVITATION_TICKET_URL = '/events/download/invitation/ticket';
export const EVENTS_GET_ALL_INVITATION_TICKETS_URL = '/events/get/all/invitation/tickets';
export const EVENTS_DELETE_INVITATION_BATCH_URL = '/events/delete/invitation/batch';
export const EVENTS_TOGGLE_INVITATION_BATCH_STATUS_URL = '/events/toggle/invitation/batch/status';
//export const EVENTS_DOWNLOAD_INVITATION_BATCH_URL = '/events/download/invitation/batch';
export const EVENTS_DOWNLOAD_INVITATION_BATCH_URL = '/events/download/tickets/zip';
export const EVENTS_TOGGLE_PRE_SELL_TICKET_STATUS_URL = '/events/toggle/pre/sell/ticket/status';
export const EVENTS_DELETE_INVITATION_TICKET_URL = '/events/delete/invitation/ticket';
export const EVENTS_DELETE_MULTIPLE_INVITATION_TICKETS_URL = '/events/delete/multiple/invitation/tickets';

// CUSTOMISATIONS
// slides
export const SLIDES_GET_ALL_SLIDES_URL = '/website/landing/slide/all'
export const SLIDES_ADD_NEW_SLIDE_URL = '/website/landing/slide/new'
export const SLIDES_UPDATE_SLIDE_URL = '/website/landing/slide/update/'
export const SLIDES_DELETE_SLIDE_URL = '/website/landing/slide/delete/'
// about
export const ABOUT_GET_INFO_ABOUT_URL = '/website/landing/about/info'
export const ABOUT_UPDATE_INFO_ABOUT_URL = '/website/landing/about/update'
export const GALLERY_UPDATE_IMAGES_URL = '/website/landing/gallery/update'
// services
export const SERVICES_GET_ALL_SERVICES_URL = '/website/landing/services/all'
export const SERVICES_ADD_NEW_SERVICE_URL = '/website/landing/service/new'
export const SERVICES_UPDATE_SERVICE_URL = '/website/landing/service/update/'
export const SERVICES_DELETE_SERVICE_URL = '/website/landing/service/delete/'
// projects
export const PROJECTS_GET_ALL_PROJECTS_URL = '/website/landing/projects/all'
export const PROJECTS_ADD_NEW_PROJECT_URL = '/website/landing/project/new'
export const PROJECTS_UPDATE_PROJECT_URL = '/website/landing/project/update/'
export const PROJECTS_DELETE_PROJECT_URL = '/website/landing/project/delete/'
// members
export const MEMBERS_GET_ALL_MEMBERS_URL = '/website/landing/members/all'
export const MEMBERS_ADD_NEW_MEMBER_URL = '/website/landing/member/new'
export const MEMBERS_UPDATE_MEMBER_URL = '/website/landing/member/update/'
export const MEMBERS_DELETE_MEMBER_URL = '/website/landing/member/delete/'
// Customization - Blogs
export const BLOGS_GET_ALL_URL = '/website/blog/all';
export const BLOGS_ADD_NEW_URL = '/website/blog/new';
export const BLOGS_UPDATE_URL = '/website/blog/update/';
export const BLOGS_DELETE_URL = '/website/blog/delete/';
export const BLOGS_GET_COMMENTS_URL = '/website/blog/';
export const BLOG_DELETE_COMMENT_URL = '/website/blog/comment/delete/';
export const BLOG_DELETE_COMMENTS_URL = '/website/blog/';

// Website Static
export const STATIC_GET_URL = '/website/static/content';
export const STATIC_UPDATE_URL = '/website/static/content/update';

// Audio Visual
export const GET_ALL_AUD_VID_URL = '/audio-visual/get/';
export const AUD_VID_ADD_NEW_URL = '/audio-visual/add';
export const AUD_VID_DELETE_URL = '/audio-visual/delete/';
export const AUD_VID_UPDATE_URL = '/audio-visual/update/';
export const GET_ALL_ARTISTS_URL = '/audio-visual/artists';
export const GET_ALL_GENRES_URL = '/audio-visual/genres';
export const GET_ALL_DIRECTORS_URL = '/audio-visual/directors';
export const GET_ALL_PLAYLISTS_URL = '/audio-visual/playlists';
export const GET_ALL_CAST_URL = '/audio-visual/cast';
export const ADD_PLAYLIST_URL = '/audio-visual/playlists/add';
export const UPDATE_PLAYLIST_URL = '/audio-visual/playlists/update/';
export const DELETE_PLAYLIST_URL = '/audio-visual/playlists/delete/';
export const GET_PLAYLISTS_ITEMS_URL = '/audio-visual/playlists/items/';

// Audio Visual Series
export const GET_ALL_SERIES_URL = '/audio-visual/series';
export const ADD_SERIES_URL = '/audio-visual/series/add';
export const UPDATE_SERIES_URL = '/audio-visual/series/update/';
export const DELETE_SERIES_URL = '/audio-visual/series/delete/';
export const GET_SERIES_GENRES_URL = '/audio-visual/series/genres';
export const GET_SERIES_DIRECTORS_URL = '/audio-visual/series/directors';
export const GET_SERIES_PLAYLISTS_URL = '/audio-visual/series/playlists';
export const GET_SERIES_CAST_URL = '/audio-visual/series/cast';

// Audio Visual Seasons
export const GET_ALL_SERIES_SEASONS_URL = '/audio-visual/series/seasons/';
export const ADD_SERIES_SEASON_URL = '/audio-visual/series/seasons/add/';
export const UPDATE_SERIES_SEASON_URL = '/audio-visual/series/seasons/update/';
export const DELETE_SERIES_SEASON_URL = '/audio-visual/series/seasons/delete/';

// Audio Visual Episodes
export const ADD_SEASONS_EPISODE_URL = '/audio-visual/series/seasons/episodes/add';
export const UPDATE_SEASONS_EPISODE_URL = '/audio-visual/series/seasons/episodes/update/';
export const DELETE_SEASONS_EPISODE_URL = '/audio-visual/series/seasons/episodes/delete/';

// Audio Visual Podcasts
export const GET_ALL_PODCASTS_URL = '/audio-visual/podcasts';
export const ADD_PODCAST_URL = '/audio-visual/podcasts/add';
export const UPDATE_PODCAST_URL = '/audio-visual/podcasts/update/';
export const DELETE_PODCAST_URL = '/audio-visual/podcasts/delete/';
export const GET_PODCASTS_DIRECTORS_URL = '/audio-visual/podcasts/directors';
export const GET_PODCASTS_PLAYLISTS_URL = '/audio-visual/podcasts/playlists';
export const GET_PODCASTS_TOPICS_URL = '/audio-visual/podcasts/topics';
export const GET_PODCASTS_EPISODES_URL = '/audio-visual/podcasts/episodes/';
export const ADD_PODCAST_EPISODE_URL = '/audio-visual/podcasts/episodes/add';
export const UPDATE_PODCAST_EPISODE_URL = '/audio-visual/podcasts/episodes/update/';
export const DELETE_PODCAST_EPISODE_URL = '/audio-visual/podcasts/episodes/delete/';

// Audio Visual Media Files
export const ADD_MEDIA_FILE_ID_URL = '/audio-visual/media/add_id';

// STREAMER MEDIA
export const GET_STREAMER_MEDIA_URL = '/audio-visual/streamer/media';
export const DELETE_STREAMER_MEDIA_URL = '/audio-visual/media/delete/';

export const ADMIN_GATEKEEPER_ADD_NEW_URL = "/gatekeeper/add/new";
export const ADMIN_GATEKEEPER_UPDATE_URL = "/gatekeeper/update/";
export const ADMIN_GATEKEEPER_GET_ALL_URL = "/gatekeeper/get/all";
export const ADMIN_GATEKEEPER_DELETE_URL = "/gatekeeper/delete";

export const ADMIN_TICKET_SELLER_GET_ALL_URL = "/ticket/seller/get/all";
export const ADMIN_TICKET_SELLER_DELETE_URL = "/ticket/seller/delete";
export const ADMIN_TICKET_SELLER_ADD_NEW_URL = "/ticket/seller/add/new";
export const ADMIN_TICKET_SELLER_UPDATE_URL = "/ticket/seller/update";

// Donation
export const DONATE_ADDNEW_DONATION_SESSION_URL = "/donation/add/new";
export const DONATE_UPDATE_DONATION_SESSION_URL = "/donation/update";
export const DONATE_DELETE_DONATION_SESSION_URL = "/donation/delete";
export const DONATE_GET_ALL_DONATION_SESSION_URL = "/donation/get/all";
export const DONATION_GET_ALL_DONETED_USERS_URL = "/donation/get/all/donated/users";
export const DONATION_DELETE_DONATED_USER_URL = "/donation/delete/donated/user";


export const PAYMENT_CHECK_STATUS_URL = "/payment/check/status";